// https://mui.com/material-ui/migration/v5-component-changes/#breakpoint-sizes
const theme = {};

theme.typography = {
  // htmlFontSize: 10,
  fontSize: 20,
  fontFamily: ["Open Sans", "sans-serif"].join(",")
  // body2: {
  //   fontSize: 30,
  //   fontFamily: "Comic Sans MS"
  // }
};

theme.components = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    }
  },
  MuiButton: {
    defaultProps: {
      color: "inherit"
    }
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        },
        "&.Mui-selected": {
          backgroundColor: "rgba(0, 0, 0, 0.08)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)"
          }
        }
      }
    }
  }
};

theme.fontFamily = "'Open Sans', sans-serif";

theme.palette = {
  // background: {
  //   default: "#404040"
  // },
  mbgreen: ["#66a220", "#c9e2ac"],
  mborange: ["#e54f00", "#ff5800", "#ffd1b9"],
  mbblue: ["#429bf4", "#cbdff4"],
  mbred: ["#a22020"],
  prblue: ["#1f7695", "#1e85a3"],
  grayscale: ["#616161", "#7d7d7d", "#b3b3b3", "#cecfcf"],
  // blue: ["#3f51b5", "#303f9f"],
  blue: ["#429BF4", "#2d90f2"]
};

theme.palette.outline = {
  primary: theme.palette.mbblue[0],
  secondary: theme.palette.mbblue[1]
};

theme.fonts = {
  primary: "Helvetica Neue, Helvetica, Roboto, sans-serif",
  pre: "Consolas, Liberation Mono, Menlo, Courier, monospace",
  quote: "Georgia, serif"
};

theme.sizes = {
  maxWidth: "1100px"
};

theme.zIndex = {
  layer: 5500,
  popover: 6000,
  eclipseLoader: 1000,
  dropdownMenu: 9999,
  pager: {
    background: 1000,
    button: 1001,
    icon: 1002
  },
  pagination: 1400,
  modal: 1600
};

theme.eclipseLoader = {
  red: "#bd1a1a",
  gray: "#e0e1e1"
};

theme.outline = (color = "var(--dsb-outline-color)") => {
  return `${color} 2px solid`;
};

export default theme;
